import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BellIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useLocation } from '@remix-run/react';

import { COMMUNITY_ROUTES, isMessagesRoute } from '~/constants/community';

import { useCommunityData } from '../../../_context/useCommunityData';
import { useCommunityMembership } from '../../../_hooks/useCommunityMembership';
import { TopBarIconLink } from './TopBarIconLink';
import { TOP_BAR_ICON_STROKE_WIDTH } from './topBarIconClasses';

interface TopBarNavLinksProps {
  notificationUnreadCount?: number | null;
}

export const TopBarNavLinks: FC<TopBarNavLinksProps> = ({ notificationUnreadCount }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isMember, isMessagesEnabled } = useCommunityMembership();
  const {
    messages: { unreadCount },
  } = useCommunityData();

  return (
    <>
      {isMessagesEnabled && (
        <TopBarIconLink
          to={COMMUNITY_ROUTES.messages}
          label={t('community.sidebar.messages')}
          icon={<ChatBubbleLeftRightIcon className="size-5" strokeWidth={TOP_BAR_ICON_STROKE_WIDTH} />}
          badgeCount={unreadCount}
          isActive={isMessagesRoute(pathname)}
        />
      )}
      {isMember && (
        <TopBarIconLink
          to={COMMUNITY_ROUTES.notifications}
          label={t('community.sidebar.notifications')}
          icon={<BellIcon className="size-5" strokeWidth={TOP_BAR_ICON_STROKE_WIDTH} />}
          badgeCount={notificationUnreadCount}
          isActive={pathname === COMMUNITY_ROUTES.notifications}
        />
      )}
    </>
  );
};
